import { FC, useState } from "react";
import { PanelGroupProps, PanelResizeHandle } from "react-resizable-panels";
import { Box, Divider, styled, useTheme } from "@mui/material";
import DragIndicatorRoundedIcon from "@mui/icons-material/DragIndicatorRounded";
export const StyledResizeHandle = styled(PanelResizeHandle, {
  shouldForwardProp: (prop) => prop !== "$width" && prop !== "$backgroundColor",
})<{
  $width: number | string;
}>`
  flex: 0 0 ${(props) => props.$width}px;
  position: relative;
  outline: none;
`;

export interface ResizeHandleProps {
  width?: number;
  direction: PanelGroupProps["direction"];
  hideDivider?: boolean;
  disabled?: boolean;
}

export const ResizeHandle: FC<ResizeHandleProps> = (props) => {
  const disabled = props.disabled ?? false;
  const width = props.width ?? 24;
  const direction = props.direction;
  const hideDivider = props.hideDivider ?? false;
  const theme = useTheme();
  const [hovering, setHovering] = useState(false);
  const backgroundColorDefault = theme.palette.background.default;
  const backgroundColorWhenHovering = theme.palette.divider;
  const backgroundColor =
    hovering && hideDivider
      ? backgroundColorWhenHovering
      : backgroundColorDefault;

  const handleColor =
    hovering && hideDivider
      ? "transparent"
      : hovering && !hideDivider
      ? theme.palette.primary.dark
      : theme.palette.divider;

  const handleMouseEnter = () => {
    if (!disabled) {
      setHovering(true);
    }
  };
  const handleMouseLeave = () => {
    if (!disabled) {
      setHovering(false);
    }
  };

  return (
    <StyledResizeHandle
      disabled={disabled}
      $width={width}
      style={{ cursor: disabled ? "default" : undefined }}
    >
      <Box
        className={"resize-handle-inner"}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        sx={{
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          borderRadius: "0.25em",
          transition: "background-color 0.2s linear",
          backgroundColor: backgroundColor,
        }}
      >
        {!hideDivider && (
          <Divider
            absolute={direction === "horizontal"}
            orientation={direction === "horizontal" ? "vertical" : "horizontal"}
            sx={{
              width: direction === "vertical" ? undefined : `${width / 2}px`,
              height: direction === "horizontal" ? undefined : `${width / 2}px`,
              borderColor: hovering ? theme.palette.primary.dark : undefined,
            }}
          />
        )}
        {!disabled && (
          <DragIndicatorRoundedIcon
            viewBox={"0 0 25 25"}
            sx={{
              color: handleColor,
              position: "absolute",
              left: "50%",
              top: "50%",
              width: "25px",
              height: "25px",
              transform:
                direction === "vertical"
                  ? "translate(-50%, -50%) rotate(90deg)"
                  : "translate(-50%, -50%)",
            }}
          />
        )}
      </Box>
    </StyledResizeHandle>
  );
};
